var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoZinli(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_19334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.558 14H5.99805L9.04257 10.6573H15.558C15.8024 10.6573 16 10.8497 16 11.0895V13.5753C16 13.8101 15.7998 14 15.558 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3898 0H1.87206C1.62767 0 1.43007 0.192363 1.43007 0.424697V2.91042C1.43007 3.15025 1.63027 3.34261 1.87206 3.34261H9.07128L0.109304 13.293C-0.14029 13.5703 0.0651052 14 0.447296 14H3.61662C3.74141 14 3.86621 13.95 3.95461 13.8501L15.7921 0.706995C16.0495 0.429693 15.8441 0 15.4541 0H13.3898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_19334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZinli);
export default __webpack_public_path__ + "static/media/logo-zinli.3bd509669c0746bb407e48b946c78c64.svg";
export { ForwardRef as ReactComponent };